export default "<div class=\"home-bkg\" #homebkg></div>\n<logo></logo>\n";